const qtySelectors = document.querySelectorAll('.cart-drawer__items .qty_input-customer');
qtySelectors.forEach((selector, index) => {
  const increse_btn = selector.closest("quantity-input");
  const nextElement = increse_btn.nextElementSibling;

  // Function to handle hover or touch
  const handleHover = function (event) {
    if(event.target.hasAttribute("disabled")){
      const lineItemParent = selector.closest('line-item');
      const nextElement_msg = lineItemParent.nextElementSibling;
      const childclass = lineItemParent.querySelector(".line-item-info");
      const existingCartNote = childclass.querySelector('.mini-cart__cart-note');
  
      if (existingCartNote) {
        existingCartNote.remove();
      }
  
      let cartNote = document.createElement('div');
      cartNote.classList.add('mini-cart__cart-note');
      let html_msg = nextElement_msg.innerHTML;
      cartNote.innerHTML = html_msg;
  
      let adjacentElement = document.querySelector('.js-quantity-drawer');
  
      childclass.appendChild(cartNote, adjacentElement);
      setTimeout(() => { cartNote.remove(); }, 1000);
  
      // Handle mouseleave or touchend
      const handleMouseLeave = function () {
        setTimeout(() => { cartNote.remove(); }, 1000);
      };
  
      childclass.addEventListener('mouseleave', handleMouseLeave);
  
      // For touch devices
      childclass.addEventListener('touchend', handleMouseLeave);
    }
  };

  // Event listeners for mouse and touch events
  nextElement.addEventListener('mouseenter', handleHover);
  nextElement.addEventListener('touchstart', handleHover);
});
